import React from "react";
import Text from "../text"; // Adjust the import path as necessary

function FAQ() {
  return (
    <div className="container mx-auto px-4 py-4">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
        {Text.faq.Title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Left Sponsor */}
        <div className="hidden md:block col-span-1 space-y-6 d-order-2 d-half-width">
          {/* <SponcerCard />
          <SponcerCard /> */}
        </div>

        {/* FAQ Section */}
        <div className="col-span-1 md:col-span-2 d-order-1 d-full-width">
          <div className="py-0 bg-gray-50">
            <div className="max-w-3xl mx-auto space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {Text.faq.Q1}
                </h3>
                <p className="text-gray-600">{Text.faq.A1}</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {Text.faq.Q2}
                </h3>
                <p className="text-gray-600">{Text.faq.A2}</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {Text.faq.Q3}
                </h3>
                <p className="text-gray-600">{Text.faq.A3}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Sponsor */}
        <div className="hidden md:block col-span-1 space-y-6 d-order-3 d-half-width">
          {/* <SponcerCard />
          <SponcerCard /> */}
        </div>
      </div>

      {/* Mobile Sponsor Card */}
      <div className="block md:hidden mt-8 space-y-4">
        {/* <SponcerCard /> */}
      </div>
    </div>
  );
}

export default FAQ;
